import { MESSAGE_TYPE } from 'src/app/core/models/home/message.model';
import { IOption } from '../../shared/form/components/form-select/form-select.model';

export const CONSTS = {
  HEADER_EDIT: $localize`Edit Notification`,
  HEADER_ADD: $localize`Add Notification`,
  DISPLAY_TYPE: $localize`Display Type`,
  BUTTON_TEXT: $localize`Save`,
  START_DATE: $localize`Start Date`,
  END_DATE: $localize`End Date`,
  START_TIME: $localize`Start Time`,
  END_TIME: $localize`End Time`,
  LABEL_TEXT: $localize`Limit Message Time`,
  HEADER: {
    NOTIFICATION: $localize`Header Notification Message`,
    PLACEHOLDER: $localize`Enter Header Message...`,
  },
  BODY: {
    NOTIFICATION: $localize`Body Notification Message`,
    PLACEHOLDER: $localize`Enter Body Message...`,
  },
};

export const DISPLAY_OPTIONS: IOption[] = [
  {
    label: $localize`Information`,
    value: MESSAGE_TYPE.INFO,
  },
  {
    label: $localize`Notice`,
    value: MESSAGE_TYPE.NOTICE,
  },
  {
    label: $localize`Alert`,
    value: MESSAGE_TYPE.ALERT,
  },
];
